module.exports = __webpack_public_path__ + "static/media/Rohit.bd026373.jpg";